import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Merge conditional class names and dedupe conflicting Tailwind utilities. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Title-case each whitespace-separated word in `str`: uppercase the first
 * character and lowercase the rest. Mirrors the legacy CRA `Form` field
 * `capitalize: true` behaviour on firstname / lastname inputs.
 *
 * Preserves the surrounding whitespace shape (leading/trailing spaces and
 * multi-space gaps are kept as the user typed them) so applying this to a
 * field value mid-edit doesn't jump the cursor or eat the space the user just
 * pressed. Callers should compare the output against the current displayed
 * value and only `setValue` when they actually differ — see Register /
 * EditProfile for the pattern.
 */
export function titleCase(str: string): string {
  if (!str) return str;
  return str.replace(/\S+/g, (word) =>
    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
  );
}
